<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmGroupRefundTravel"
      :title="this.$lang.GroupRefundTravel.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtGroupsName"><small class="text-danger">*</small> {{$lang.GroupRefundTravel.LabelName}}:</label>
          <div class="input-group">
            <b-form-input type="text"
                          ref="txtGroupName"
                          name="txtGroupName"
                          :placeholder="$lang.Groups.PlaceholderEnterName"
                          v-model="form.nome.value"
                          :maxlength="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row" style="height: calc(100vh - 425px);">
        <div class="col-md-5">
          <label for="txtName">{{$lang.GroupRefundTravel.LabelAvailable}}:</label>
          <div class="input-group" style="height: 95%;">
            <b-form-select
              v-model="gruposDisponiveisIds"
              :options="gruposDisponiveis"
              multiple
              :select-size="15"
              class="mb-3"
            />
          </div>
        </div>
        <div class="col-md-2 text-center">
          <div class="d-none d-md-block">
            <b-button-group style="padding-top: 150px;">
              <button type="button" class="btn btn-default btn text-secondary" @click="onRemoveGroups"><i class="fa fa-arrow-circle-left"></i></button>
              <button type="button" class="btn btn-third btn text-default" @click="onAddGroups"><i class="fa fa-arrow-circle-right"></i></button>
            </b-button-group>
          </div>
        </div>
        <div class="col-md-5">
          <label for="txtName">{{$lang.GroupRefundTravel.LabelUsed}}:</label>
          <div class="input-group" style="height: 95%;">
            <b-form-select
              v-model="gruposSelecionadosIds"
              :options="gruposSelecionados"
              multiple
              :select-size="15"
              class="mb-3"
              :class="{ 'is-invalid': erroGrupos }"
            />
            <div class="invalid-feedback" v-if="erroGrupos">
              É necessário selecionar pelo menos um grupo.
            </div>
          </div>
        </div>
      </div>
    </Forms>
    <Tables ref="tableGrid"
        :columns="[$lang.GroupRefundTravel.LabelName,
                    $lang.Common.DataTable.Status,
                    $lang.Common.DataTable.ActionDate,
                    $lang.Common.DataTable.AccountAction,
                    $lang.Common.DataTable.Actions]"
        :showSearch="true"
        :showPrint="true"
        :showDownload="true"
        :showFullscreen="true"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.nome" />
        <TableColumn :IsStatus="true" v-on:Edit="onSelect(obj)" :status="obj.status" />
        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataAcao" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.nomeContaAcao" />
        <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import GroupRefundTravel from './grouprefundtravel.js'
export default GroupRefundTravel
</script>

<style>
  div.popover-details.popover {
    max-width: 400px;
    max-height: 40vh;
  }

  div.popover-details div.popover-body {
    max-width: 400px;
    max-height: 40vh;
  }

  div.popover-details.popover p {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/configuration/grouprefundtravel/grouprefundtravel.vue